import { render, staticRenderFns } from "./TransferPage.vue?vue&type=template&id=7df885e2&scoped=true"
import script from "./TransferPage.vue?vue&type=script&lang=js"
export * from "./TransferPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7df885e2",
  null
  
)

export default component.exports